<template>
	<div class="main">
		<div class="mainIn">
			<el-row type="flex" align="middle" justify="center" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">成本中心</el-col>
				<el-col :span="16" class="alignLeft" @click.native="getCostCenter({type:'web'})">
					<popover-table class="public_font" v-model="costForm.costCenter" selectField="costCenter" :tableTitle="costCenterTitle"
                         :tableData="costList" :total="total" :pageSize="5" :pageIndex="pageIndex"
                         :inputSearch="SearchCostCenterList" :tableLoading="tableLoading" @getRowData="getSelectCostCenter">
					</popover-table>
				</el-col>
			</el-row>
			<el-row type="flex" align="middle" class="item">
				<el-col :span="8" class="alignLeft public_font" :class="{verify_item: costForm.costCenterChildItem.length > 0 ? true : false}">WBS Code</el-col>
				<el-col :span="16" class="alignLeft">
					<popover-table class="public_font" v-model="costForm.wbs" selectField="wbselement" :tableTitle="codeTitle" :tableData="codeList"
                         :total="total" :pageSize="5" :pageIndex="pageIndex" :tableLoading="tableLoading" :inputSearch="SearchWbsList">
					</popover-table>
				</el-col>
			</el-row>
			<el-row type="flex" align="middle" class="item">
				<el-col :span="8" class="alignLeft verify_item public_font">分摊预算百分比</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input-number :min="0" :controls="false" v-model="costForm.rate" placeholder="请输入分摊预算百分比" class="width280 public_font"></el-input-number>
				</el-col>
			</el-row>
			<el-row type="flex" align="start" class="item">
				<el-col :span="8" class="alignLeft public_font">财务部业务伙伴</el-col>
				<el-col :span="16" class="alignLeft" @click.native="queryAsync({type:'web'})">
					<popover-table class="public_font" v-model="costForm.partnerName" selectField="cName" :tableTitle="organizeTitle"
                         :tableData="employeeList" :total="total" :pageSize="5" :pageIndex="pageIndex" :inputSearch="queryAsync">
					</popover-table>
				</el-col>
			</el-row>
			<el-row type="flex" align="start" class="item">
				<el-col :span="8" class="alignLeft public_font">电子邮件地址</el-col>
				<el-col :span="16" class="alignLeft">
					<el-input type="email" v-model="costForm.partnerEmail" placeholder="请输入电子邮件地址" class="width280 public_font"></el-input>
				</el-col>
			</el-row>
			<el-row class="footer">
				<el-button class="widthMin100 falseBtn" @click.native="doAsync(false)">取消</el-button>
				<el-button class="widthMin100 sureBtn" :loading="btnLoading || isGetWbs" @click.native="doAsync(true)">{{isGetWbs ? '正在验证WBS是否必填' : '确定'}}</el-button>
			</el-row>
		</div>
	</div>
</template>

<script>
	import popoverTable from './popoverTable';
	import costEditor from "@scripts/components/costEditor";
	import costCenterSelector from "@scripts/components/costCenterSelector";
	import employeeSelector from '@scripts/components/employeeSelector.js';
	import { iStorage } from 'smart-core-util';
	export default {
		mixins: [costEditor, costCenterSelector, employeeSelector],
		components: {
			popoverTable
		},
		data() {
			return {
				doType: true,
				btnLoading: false,
        isGetWbs: false,
				costCenterTitle: [{
					titleId: 'costCenter',
					titleText: '代码'
				}, {
					titleId: 'description',
					titleText: '描述'
				}],
				codeTitle: [{
					titleId: 'wbselement',
					titleText: '代码'
				}, {
					titleId: 'description',
					titleText: '描述'
				}],
				organizeTitle: [{
					titleId: 'cName',
					titleText: '姓名'
				}, {
					titleId: 'identifyCode',
					titleText: '员工号'
				}, {
					titleId: 'dept',
					titleText: '部门'
				}, {
					titleId: 'email',
					titleText: '邮箱'
				}],
				modelData: {},
				isEdit: false //编辑状态，同APP逻辑保持一致
			}
		},
		watch: {
			//监听财务伙伴，取值邮箱，带出来得
			['costForm.partnerName']() {
				if(this.costForm.partnerName && this.employeeList.length > 0) {
					this.employeeList.map((ele) => {
						if(this.costForm.partnerName == ele.cName) {
							this.costForm.partnerEmail = ele.email;
							this.costForm.employeeId = ele.employeeId;
						}
					})
				}
			},
		},
		created() {
//			window.addEventListener('message', this.getCost, false);
			this.getCost();
		},
		methods: {
			//注意处理编辑，会议idTODO
			getCost() {
				this.modelData = this.iStorage.get('model');
				this.iStorage.set('proposalId', this.modelData.miceId)
				if(this.modelData.addType == 'edit') {
					this.isEdit = true;
					for(var key in this.modelData) {
						this.costForm[key] = this.modelData[key];
					}
					this.costForm.rate = Number(this.modelData.rate.replace('%', ''));
				} else if(this.modelData.addType == 'add') {
					this.isEdit = false;
				}
			},
			async doAsync(type) {
				this.doType = type;
				if(this.doType) {
					this.btnLoading = true
					await this.saveAsync({
						onSuccess: (response) => {
							console.log(response)
							this.$message({
								message: '保存成功',
								type: 'success'
							})
							this.postMessage();
						},
						toast: null,
						$messageError: (error) => {
							this.$message.error(error)
						},
						type: 'web'
					});
					this.btnLoading = false
				} else {
					this.postMessage();
					return;
				}
			},
			postMessage() {
				let data = {
					from: "simulator",
					to: "allocationEditor",
					type: this.doType
				};
				window.parent.postMessage(data, "*");
			},
      // 获取选中的成本中心信息
      async getSelectCostCenter (data) {
			    this.isGetWbs = true
			    await this.getWBSCode({costCenter:data.costCenter, keyword: '', type: 'web'})
          this.isGetWbs = false
          this.$set(this.costForm, 'costCenterChildItem', this.codeList)
          this.$set(this.costForm, 'wbs', '')
      }
		}
	}
</script>

<style scoped>
	@import '../assets/css/public.css';
	.main {
		width: 520px;
		margin: 0 auto;
		padding: 0 0 50px;
		color: #666666;
		font-size: 16px;
	}

	.mainIn {
		padding: 0 50px;
	}

	.item {
		padding: 10px 0;
	}

	.footer {
		margin: 20px 0 0;
	}
</style>

<style>
	.public_font {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-input__inner {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-textarea__inner{
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.public_font .el-textarea__inner::-webkit-input-placeholder {
		color: #CCCCCC;
		font-size: 11px;
	}

	.public_font .el-textarea__inner:-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}

	.public_font .el-textarea__inner::-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}

	.public_font .el-textarea__inner:-ms-input-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}
  .widthMin100 {
    min-width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/allocationEditor.vue